import Int from '../../public/locales/en-US.json';

export type IntlKeysType = keyof typeof Int;

export const IntlKeys = [...Object.keys(Int)].reduce((o, k) => ({ ...o, [k]: k }), {}) as {
  [P in IntlKeysType]: P;
};
